import type { TwoBusinessRegistrationGetResponseType } from "@sellar-io/api-v2/types";
import { useQuery } from "@tanstack/react-query";
import {
  apiV2AssertResponse,
  ApiV2QueryOptions,
  apiV2Request,
  getDefaultQueryOptionsV2,
} from "../../../../../hooks/api/v2/apiV2Request";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../../hooks/useFirebaseUser.shared";
import { ServerStateKeys } from "../../../../../hooks/api/v2/ServerStateKeys";

export const useGetTwoBusinessRegistrationApplication = <
  TData = TwoBusinessRegistrationGetResponseType,
>(
  options?: ApiV2QueryOptions<TData>,
) => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useQuery({
    queryKey: [user?.uid, business?.id, ServerStateKeys.TwoCreditLimitQuote],
    queryFn: () =>
      apiV2Request({
        user,
        business,
        method: "get",
        path: `two/business-registration`,
      }).then((data) => apiV2AssertResponse<TData>(data).data),
    ...getDefaultQueryOptionsV2({
      context: { scope: "business", user, business: business },
      options: {
        ...options,
      },
    }),
  });
};
